module.exports = __webpack_public_path__ + "img/T914.84c93750.jpg";